import serverCall from "../../serverCall";

const addCountry = async (country, data) => {
  const uppercaseCountry = country.toUpperCase();
  const countryName = encodeURIComponent(uppercaseCountry);
  const response = await serverCall.post(
    `/country/create/admin?countryName=${countryName}`,
    data
  );
  return response;
};
const addCountryImageRatio = async (id, data) => {
  const response = await serverCall.post(
    `/country/upload-image/admin?countryId=${id}`,
    data
  );
  return response;
};

const GetCountry = async (search, page) => {
  const response = await serverCall.get(
    `/country/find-all/admin?search=${search}&page=${page}&limit=${12}`
  );
  return response;
};

const UpdateCountry = async (id, country, data) => {
  const countryName = encodeURIComponent(country);
  const response = await serverCall.post(
    `/country/update/admin?countryId=${id}&countryName=${countryName}`,
    data
  );
  return response;
};

const GetCountryList = async (search, page) => {
  const response = await serverCall.get(
    `/country/find-all/admin?search=${search}&page=${page}&limit=${12}`
  );
  return response;
};

const GetCountryListForRace = async (search, page) => {
  const response = await serverCall.get(`/country/find-all/admin`);
  return response;
};
const GetCountryListdrpdown = async () => {
  const response = await serverCall.get(`/country/find-all/admin`);
  return response;
};

const GetSingleCountry = async (id) => {
  const response = await serverCall.get(
    `/country/find-one/admin?countryId=${id}`
  );
  return response;
};

const DeleteCountry = async (id) => {
  const response = await serverCall.delete(
    `/country/delete/admin?countryId=${id}`
  );
  return response;
};

const CountryService = {
  addCountry,
  GetCountry,
  GetSingleCountry,
  DeleteCountry,
  GetCountryList,
  GetCountryListdrpdown,
  UpdateCountry,
  addCountryImageRatio,
  GetCountryListForRace,
};

export default CountryService;
